import React from "react";
import { Grid } from "@material-ui/core";
import AllocationChart from "components/AllocationChart";
import { loadAllocationHistories } from "redux/allocationHistory/allocationHistoryFunctions";
import { useSelector, useDispatch } from "react-redux";
import { getReportDateSelector } from "redux/user/user";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";

const AllocationHistory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const reportControlId = useSelector(
    (state: RootState) => state.user.reportControlId
  );
  const reportDate = useSelector(getReportDateSelector);

  const allocationHistory = useSelector(
    (state: RootState) => state.allocationHistory.all?.data ?? []
  );
  const allocationHistoryLoading = useSelector(
    (state: RootState) => state.allocationHistory.all?.loading
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadAllocationHistories(reportControlId, reportDate));
    }
  }, [dispatch, reportControlId, reportDate]);

  return (
    <Grid
      item
      md={6}
      sm={12}
      style={{ marginBottom: 32, position: "relative" }}
    >
      <h3 style={{ color: "#444443", marginTop: 0 }}>
        {t("allocation_history")}
      </h3>
      <AllocationChart
        data={allocationHistory}
        loading={allocationHistoryLoading}
      />
    </Grid>
  );
};

export default React.memo(AllocationHistory);
